import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "button", "content"]
  static values = {
    openId: { type: String, default: null }
  }

  connect() {
    // Initialize all sections as closed
    this.sectionTargets.forEach(section => {
      const content = section.querySelector('[data-accordion-target="content"]')
      content.style.height = "0px"
      content.classList.add("overflow-hidden") 
      section.removeAttribute("open")
    })
    
    // Then open the target section if specified
    this.openIdValueChanged()
  }

  openIdValueChanged() {
    this.sectionTargets.forEach(section => {
      const shouldBeOpen = this.openIdValue && section.id === this.openIdValue
      this.toggleSection(section, shouldBeOpen)
    })
  }

  toggleSection(section, forceOpen = null) {
    const content = section.querySelector('[data-accordion-target="content"]')
    const isCurrentlyOpen = section.hasAttribute("open")
    const shouldOpen = forceOpen !== null ? forceOpen : !isCurrentlyOpen

    if (shouldOpen === isCurrentlyOpen) return // No change needed

    if (shouldOpen) {
      // Opening
      section.setAttribute("open", "open")
      content.style.height = "0px"
      content.classList.add("overflow-hidden")
      
      requestAnimationFrame(() => {
        content.style.height = `${content.scrollHeight}px`
      })

      content.addEventListener("transitionend", function handler() {
        if (section.hasAttribute("open")) {
          content.style.height = "auto"
          content.classList.remove("overflow-hidden")
        }
        content.removeEventListener("transitionend", handler)
      })
    } else {
      // Closing
      content.style.height = `${content.scrollHeight}px`
      content.classList.add("overflow-hidden")
      
      requestAnimationFrame(() => {
        content.style.height = "0px"
      })
      
      section.removeAttribute("open")

      content.addEventListener("transitionend", function handler() {
        if (!section.hasAttribute("open")) {
          content.style.height = "0px"
        }
        content.removeEventListener("transitionend", handler)
      })
    }
  }

  toggle(event) {
    const section = event.currentTarget.closest('[data-accordion-target="section"]')
    const isOpen = section.hasAttribute("open")

    if (isOpen) {
      this.openIdValue = null
    } else {
      this.openIdValue = section.id
    }
  }
}